export default {
  title: 'مدیریت سرفصل ها',
  btnAddChapters:'اضافه کردن سرفصل',
  btnEditChapter:' ویرایش سرفصل',
  btnEditMedia:'ویرایش رسانه',
  btnAddMedia:'اضافه کردن رسانه',
  labelTitle:'عنوان',


  typeClip:'ویدیو',
  typeAudio:'صدا',
  typeGame:'بازی',
  labelLink:'نشانی وب',

  edit:'ویرایش',
  editMedia:'ویرایش رسانه',
  labelNameFa:'نام فارسی',
  labelNameEn:'نام لاتین',
  labelType:'نوع',
  back:'لغو',
  save:'ذخیره',
  saving:'در حال ذخیره',


  placeholderNameEn:'نام لاتین را وارد نماید',
  placeholderNameFa:'نام فارسی را وارد نماید',
  placeholderTitle:'عنوان را وارد نماید',
  placeholderType:'عنوان را وارد نماید',
  placeholderLink:'نشانی را وارد نماید',
  deleteConfirm:'آیا مطمئن هستید؟',


  loading:'در حال بارگزاری',
  empty:'دیتایی یافت نشد',

}
